import { FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import React from 'react';
import { IRiskManagementLastConsultation } from 'services/riskManagement/types';

import logoGuep from '../../../../../../public/assets/guep.svg';
import logoSkymark from '../../../../../../public/assets/skymark.svg';
import { Card } from '../Card';
import * as Styled from './styled';

export const ContentCard: React.FC<IRiskManagementLastConsultation> = ({ company, freight, grDate, partner }) => (
  <Card testId="last-consultation-info-card">
    <FuelFlex defaultProps={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Styled.TextWrapper>
        <FuelTypography weight="bold" spacingBottom={2}>
          {company.name}
        </FuelTypography>
      </Styled.TextWrapper>
      <Styled.TextWrapper>
        <FuelTypography size="caption" color="neutral-default" weight="medium">
          {grDate} • {freight.typeMerchandise}
        </FuelTypography>
      </Styled.TextWrapper>
    </FuelFlex>
    <FuelFlex
      defaultProps={{
        display: 'flex',
        flexDirection: 'row',
        gap: 'km4',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      <FuelTypography color="neutral-default" weight="medium">
        Consultado em
      </FuelTypography>
      <Styled.ImgWrapper>
        {partner.name === 'skymark' ? (
          <img src={logoSkymark} alt="skymark logo" height={17} data-testid="skymark-logo" />
        ) : (
          <img src={logoGuep} alt="guep logo" height={22} data-testid="guep-logo" />
        )}
      </Styled.ImgWrapper>
    </FuelFlex>
  </Card>
);
